import styles from './MultiFileUploader.module.css';
import { useRef, useState } from "react"

import { SlCloudUpload } from "react-icons/sl";
import { AiOutlineFilePdf, AiOutlineFileImage, AiOutlineFileWord, AiOutlineFileExcel, AiOutlineFileUnknown, AiOutlineClose } from "react-icons/ai";

const MultiFileUploader = ({ files, setFiles, accept, maxFiles = 5, maxSizeMB = 5 }) => {

    const inputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    // Casp maxFiles for 0, deixar sem limite

    if (maxFiles === 0) {
        maxFiles = Infinity;
    }

    const handleFiles = (fileList) => {
        const incoming = Array.from(fileList).slice(0, maxFiles - files.length);
        const next = incoming.map(f => ({
            file: f,
            id: `${Date.now()}-${Math.random()}`
        }))
        setFiles(prev => [...prev, ...next]);
    }

    const getFileIcon = (file) => {
        const name = file.name.toLowerCase();

        if (file.type.startsWith("image/")) return <AiOutlineFileImage size={22} color="#4a90e2" />;
        if (file.type === "application/pdf" || name.endsWith(".pdf")) return <AiOutlineFilePdf size={22} color="#e63946" />;
        if (name.endsWith(".doc") || name.endsWith(".docx")) return <AiOutlineFileWord size={22} color="#2a6db0" />;
        if (name.endsWith(".xls") || name.endsWith(".xlsx")) return <AiOutlineFileExcel size={22} color="#207245" />;

        return <AiOutlineFileUnknown size={22} color="#555" />;
    }

    const formatSize = (bytes) => {
        if (bytes < 1024) return `${bytes}B`
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`
        return `${(bytes / 1024 / 1024).toFixed(1)}MB`
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (e.dataTransfer?.files?.length) {
            handleFiles(e.dataTransfer.files);
        }
    };

    return (
        <div className={styles.container} >
            <div
                className={`${styles.clickArea} ${isDragging ? styles.dragging : ""}`}
                onClick={() => inputRef.current && inputRef.current.click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <SlCloudUpload />
                <p>ADICIONAR ARQUIVO</p>
                <input
                    type="file"
                    multiple
                    accept="*"
                    capture={accept?.includes('image') ? 'environment' : undefined}
                    className={styles.hiddenInput}
                    ref={inputRef}
                    onChange={(e) => handleFiles(e.target.files)}
                />
            </div>

            {files.length > 0 && (
                <div className={styles.fileList} >
                    {files.map(f => (
                        <div className={styles.fileContainer} key={f.id} >
                            <div className={styles.fileIconCont} >
                                <span className={styles.fileIcon} >{getFileIcon(f.file)}</span>
                            </div>
                            <div className={styles.fileInfo} >
                                <p><strong>{f.file.name}</strong></p>
                                <p>{formatSize(f.file.size)}</p>
                            </div>
                            <div className={styles.removeContainer} >
                                <span>
                                    <AiOutlineClose
                                        onClick={() => setFiles(files.filter(x => x.id !== f.id))}
                                    />
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )

}

export default MultiFileUploader;